module.exports = __webpack_public_path__ + "img/TraumVIII.ecded2bf.jpg";